// Group carparks by carpark name
// Only groups them if they are adjacent in the array.
export const groupCarparks = (carparks) => {
  const groupedCarparks = carparks.reduce((acc, curr, index) => {
    const currentName = curr.name;
    const lastName = carparks[index - 1]?.name;

    const listWithoutLast = acc.slice(0, acc.length - 1);
    const last = acc[acc.length - 1];

    if (currentName === lastName) {
      return [
        ...listWithoutLast,
        { ...last, carparks: [...last.carparks, curr] },
      ];
    }
    return [...acc, { name: currentName, carparks: [curr] }];
  }, []);

  return groupedCarparks;
};
